/**
 * @typedef Item - comes from backend TreeViewSearchController
 * @type {object}
 * @property {string} hash
 * @property {number} taId
 * @property {string} application
 * @property {string} url
 * @property {string} title
 * @property {string} titleLatin
 * @property {[string]} highlightTerms
 * @property {string} [parentTitle]
 * @property {string} [parentPath]
 * @property {string} iconName
 */

export default {
    namespaced: true,
    state: {
        /** @type {Item[]} */
        items: [],
        activeIndex: 0,
    },
    getters: {
        items: (state) => state.items,
        activeIndex: (state) => state.activeIndex,
        activeItem: (state) => state.items[state.activeIndex],
    },
    mutations: {
        setItems: (state, { items }) => state.items = items,
        setActiveIndex: (state, { index }) => state.activeIndex = index,
        incrementActiveIndex: (state) => state.activeIndex++,
        decrementActiveIndex: (state) => state.activeIndex--,
    },
    actions: {
        setItems: ({ commit }, { items }) => commit('setItems', { items }),
        setActiveItem: ({ commit, getters }, { item: itemToSetActive }) => {
            const index = getters.items.findIndex(item => item.hash === itemToSetActive.hash)
            commit('setActiveIndex', { index })
        },
        navigateNextIndex: ({ commit, getters }) => {
            if (getters.activeIndex < (getters.items.length - 1)) {
                commit('incrementActiveIndex')
            }
        },
        navigatePreviousIndex: ({ commit, getters }) => {
            if (getters.activeIndex > 0) {
                commit('decrementActiveIndex')
            }
        },
        openItem: ({ getters, dispatch }) => {
            dispatch('visitItem', { item: getters.activeItem }, { root: true });
            window.location.href = getters.activeItem.url;
        }
    }
};

